// SPDX-License-Identifier: MIT
import { AzureProviderConfig, AzureConfigValidationResult } from '../types';

export interface AzureRawEnvConfig {
  VITE_AZURE_ACCOUNT_NAME?: string;
  VITE_AZURE_CONTAINER_NAME?: string;
  VITE_AZURE_ROOT_PREFIX?: string;
  VITE_LOCAL_SAS_SECRET?: string;
  VITE_LOCAL_SAS_PBKDF2_ITERATIONS?: string;
}

const NAME_RE = /^[a-z0-9-]{3,63}$/;
const PREFIX_RE = /^[A-Za-z0-9_\-/]*$/;

export function validateAzureConfig(
  overrides?: Partial<AzureRawEnvConfig>
): AzureConfigValidationResult {
  const envBase: AzureRawEnvConfig = {
    VITE_AZURE_ACCOUNT_NAME: import.meta.env.VITE_AZURE_ACCOUNT_NAME,
    VITE_AZURE_CONTAINER_NAME: import.meta.env.VITE_AZURE_CONTAINER_NAME,
    VITE_AZURE_ROOT_PREFIX: import.meta.env.VITE_AZURE_ROOT_PREFIX,
    VITE_LOCAL_SAS_SECRET: import.meta.env.VITE_LOCAL_SAS_SECRET,
    VITE_LOCAL_SAS_PBKDF2_ITERATIONS: import.meta.env.VITE_LOCAL_SAS_PBKDF2_ITERATIONS,
  };
  const env = { ...envBase, ...(overrides || {}) } as AzureRawEnvConfig;
  const issues: AzureConfigValidationResult['issues'] = [];
  const enabled = true; // feature flag gating removed
  const accountName = env.VITE_AZURE_ACCOUNT_NAME?.trim();
  const containerName = env.VITE_AZURE_CONTAINER_NAME?.trim();
  // Strip leading/trailing slashes and leading dots
  const rootPrefix = env.VITE_AZURE_ROOT_PREFIX
    ? env.VITE_AZURE_ROOT_PREFIX.replace(/^\/+/, '').replace(/\/+$/, '').replace(/^\.+/, '') ||
      undefined
    : undefined;
  if (accountName && !NAME_RE.test(accountName))
    issues.push({
      field: 'accountName',
      message: 'Invalid account name format',
      severity: 'error',
    });
  if (containerName && !NAME_RE.test(containerName))
    issues.push({
      field: 'containerName',
      message: 'Invalid container name format',
      severity: 'error',
    });
  if (rootPrefix && !PREFIX_RE.test(rootPrefix))
    issues.push({
      field: 'rootPrefix',
      message: 'Root prefix contains invalid characters',
      severity: 'error',
    });
  const config: AzureProviderConfig = { enabled, accountName, containerName, rootPrefix };
  // Decrypt now allowed in all environments; no guardrail needed
  return { valid: !issues.some(i => i.severity === 'error'), issues, config };
}
